module.exports = __webpack_public_path__ + "static/media/marvelous_05.0fab37cc.jpg";